import { forwardRef } from "react";

const Checkbox = forwardRef(function Checkbox(
  { label, disabled = false, className = "", id, ...rest },
  ref
) {
  return (
    <label className={`peb-checkbox ${disabled ? "peb-checkbox--disabled" : ""} ${className}`} htmlFor={id}>
      <input
        ref={ref}
        id={id}
        type="checkbox"
        className="peb-checkbox__input"
        disabled={disabled}
        data-testid={id ? `checkbox-${id}` : "checkbox"}
        {...rest}
      />
      {label != null && <span className="peb-checkbox__label">{label}</span>}
    </label>
  );
});

export default Checkbox;
